import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  Button,
  CircularProgress,
} from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import HomeWorkIcon from '@material-ui/icons/HomeWork';
import MenuOpenIcon from '@material-ui/icons/MenuOpen';
import AccountTreeIcon from '@material-ui/icons/AccountTree';
import AdminUserTable from "../table/AdminUserTable"; // Assuming AdminUserTable is in the same directory
import CreateEditUserDrawer from "./CreateEditUserDrawer"; // Import the CreateEditUserDrawer component
import GrandparentAccountTable from "../table/GrandparentAccountTable";
import { Divider } from "semantic-ui-react";
import CreateEditGrandparentAccountDrawer from "./CreateEditGrandparentAccountDrawer";
import ClientAdminUserTable from "../table/ClientAdminUserTable";

const useStyles = makeStyles((theme) => ({
  root: {
    height: window.innerHeight,
    backgroundImage: "url('/path/to/background-image.jpg')",
  },
  card: {
    width: '94%',
    // height: 850,
    marginLeft: '3%',
    marginTop: '1%',
    backgroundColor: 'whitesmoke',
  },
  header: {
    backgroundColor: '#0055a4',
  },
  headerText: {
    fontSize: 23,
    paddingBottom: 5,
    color: 'white',
  },
  logo: {
    width: '5%',
    paddingTop: 20,
    paddingLeft: 15,
    paddingBottom: 0,
    paddingRight: 5,
  },
  button: {
    margin: theme.spacing(1),
  },
  proceed: {
    "&:hover": {
      opacity: 1,
    },
    background:
      "transparent linear-gradient(90deg, #0055A4 0%, #0079E6 100%) 0% 0% no-repeat padding-box",
    borderRadius: 18,
    font: 'Barlow',
    opacity: .8,
    fontWeight: 500,
    color: "#FFFFFF",
    boxShadow: "none",
  },
}));

const UserManagementPage = () => {
  const classes = useStyles();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [grandparentDrawerOpen, setGrandparentDrawerOpen] = useState(false);
  const userAccountInfo = JSON.parse(localStorage.getItem('accountInfo'));

  const handleGrandparentDrawerOpen = () => {
    setGrandparentDrawerOpen(true);
  }

  const handleUserDrawerOpen = () => {
    setDrawerOpen(true);
  };

  const handleDrawerClose = () => {
    setDrawerOpen(false);
    setGrandparentDrawerOpen(false);
  };


  const goToHomePage = () => {
    history.push({ pathname: "/home" });
  };
    

  return (
    <div style={{ height: window.innerHeight }} className="background-image-login-grad">
      <div className="background-image-login">
        <Grid container>
          <Card className={classes.card}>
            <CardContent style={{ padding: 0 }}>
              <Grid container>
                <Grid item sm={10} className={classes.header}>
                  <Typography variant="body2" className={classes.headerText}>
                    <img
                      src={require("../../../assets/logo.svg")}
                      className={classes.logo}
                      alt="emtrack-logo"
                    />
                    USER MANAGEMENT PAGE
                  </Typography>
                </Grid>
                <Grid item sm={2} className={classes.header} style={{paddingTop:20, paddingLeft:40}}>
                <Button
                    variant="contained"
                    color="primary"
                    className={classes.proceed}
                    startIcon={<HomeWorkIcon />}
                    onClick={goToHomePage}
                    disabled={loading}
                    style={{background:'bottom'}}
                  >
                    Go to Home Page
                  </Button>
                </Grid>
                <Grid item sm={12} style={{ paddingTop: 40, paddingLeft: 20 }}>
                  <Button
                    variant="contained"
                    color="primary"
                    className={classes.proceed}
                    startIcon={<AddIcon />}
                    onClick={handleUserDrawerOpen}
                    disabled={loading}
                  >
                    {loading ? <CircularProgress size={24} color="inherit" /> : "Create User"}
                  </Button>
                </Grid>


                {userAccountInfo?.userProfile?.userRole === 'EMTCADMIN' ? 
                <>
                  <Grid item sm={12} style={{ paddingTop: 5 }}>
                    <ClientAdminUserTable/>
                    <Divider/>
                  </Grid>
                </> : 
                <>
                  <Grid item sm={12} style={{ paddingTop: 5 }}>
                    <AdminUserTable/>
                    <Divider/>
                  </Grid>
                  <Grid item sm={12} style={{ paddingTop: 10, paddingLeft: 20 }}>
                    <Button
                      variant="contained"
                      color="primary"
                      className={classes.proceed}
                      startIcon={<AccountTreeIcon />}
                      onClick={handleGrandparentDrawerOpen}
                      disabled={loading}
                    >
                      {loading ? <CircularProgress size={24} color="inherit" /> : "Grandparent Account Options"}
                    </Button>
                  </Grid>
                  <Grid item sm={12} style={{ paddingTop:'0.5%', paddingBottom:'1.5%' }}>
                    <GrandparentAccountTable/>
                  </Grid>
                  
                  <CreateEditGrandparentAccountDrawer
                  open={grandparentDrawerOpen}
                  onClose={handleDrawerClose}
                  // onCreate={handleUserCreate}
                />
                </>}
              </Grid>
            </CardContent>
          </Card>
        </Grid>
        <CreateEditUserDrawer
          open={drawerOpen}
          onClose={handleDrawerClose}
          // onCreate={handleUserCreate}
        />
       
       
      </div>
    </div>
  );
};

export default UserManagementPage;